export default function CircleDrop(props) {
  return (
    <div className="circle-drop pointer" onClick={props.onClick}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
